import React, { useMemo, useState } from 'react';
import HeaderContext from '@app/shell/state/HeaderContext';
import { ProviderProps } from '@app/shell/types';

const HeaderProvider = ({ children }: Pick<ProviderProps, 'children'>) => {
  const [data, setData] = useState<Record<string, any>>({});

  const value = useMemo(() => ({ data, setData }), [data]);

  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  );
};

export default HeaderProvider;
